import {CommonMessages} from '../common.messages';

export const PanelBankAccountsMessages = {
    GetLinkedAccountsFailed: {
        key: 'GetLinkedAccountsFailed',
        message: 'Error while communication with the server. Unable to get bank accounts.'
    },
    ...CommonMessages
};
